import {appStates} from '@/constants'
import {getUser} from '@/composables/user'
import {getInOrgSite, getIsVkApp, getIsVkAppContextless, getSourceId} from '@/composables/context'

function isBackSupport (showMenu, currentState) {
  if (!getUser().authorized || currentState === appStates.acquiringPaymentResult.name) {
    return false
  }
  let res
  if (getInOrgSite() || getIsVkApp()) {
    res = showMenu && currentState !== appStates.sourceItemContent.name
      && currentState !== appStates.sourceList.name
  } else if (getIsVkAppContextless()) {
    res =  showMenu && currentState !== appStates.sourceList.name
  } else {
    res = showMenu && currentState !== appStates.sourceList.name
  }
  return res && currentState !== appStates.needPay.name
}

function toBackState (currentState, currentParams) {
  let name
  const params = {}
  switch (currentState){
    case appStates.messagePermissions.name:
    case appStates.sourceItemEventList.name:
    case appStates.sourceItemSettings.name:
    case appStates.sourceItemUserProfile.name:
      return null
    case appStates.sourceItemBuyoutItem.name:
      params.sourceId = currentParams.sourceId
      if (params.sourceId){
        name = appStates.sourceItemContent.name
      } else {
        name = appStates.sourceList.name
      }
      break
    case appStates.acquiringAbout.name:
    case appStates.acquiringDemoProducts.name:
    case appStates.acquiringDocuments.name:
    case appStates.acquiringPaymentInfo.name:
      params.sourceId = getSourceId()
      if (params.sourceId) {
        name = appStates.sourceItemContent.name
      } else {
        name = appStates.sourceList.name
      }
      break;
    case appStates.buyoutPayment.name:
    case appStates.buyoutPaymentConfirmation.name:
    case appStates.buyoutPickupPointSet.name:
    case appStates.buyoutBalance.name:
      return null
    default:
      name = appStates.sourceList.name
      break
  }
  return {name, params}
}

export {
  isBackSupport,
  toBackState
}
